import { calculatePotentialReturns } from './calculatePotentialReturns';

interface TotalPotentialReturnsOptions {
  stakePerLine: number;
  returnFactor?: number;
  placeReturnFactor?: number;
  numberOfLines: number;
  eachWaySelected?: boolean;
  isFreeBet: boolean;
}

export const calculateTotalPotentialReturns = ({
  stakePerLine,
  numberOfLines,
  returnFactor,
  placeReturnFactor,
  eachWaySelected,
  isFreeBet
}: TotalPotentialReturnsOptions) => {
  const winPotentialReturn = calculatePotentialReturns({
    stake: stakePerLine,
    returnFactor: returnFactor || 0,
    numberOfLines,
    isFreeBet
  });
  const placePotentialReturn = eachWaySelected
    ? calculatePotentialReturns({
        stake: stakePerLine,
        returnFactor: placeReturnFactor || 0,
        numberOfLines,
        isFreeBet
      })
    : 0;

  return winPotentialReturn + placePotentialReturn;
};
